import React from "react"
import { useTranslation } from 'react-i18next'
import { formatMoney } from "helpers/helpers";

const Tree = ({ children, selectItem, editItem, openTransactions, openCorrection, deleteItem, level = 0 }) => {
	const { t } = useTranslation()

	function returnEntityType(item) {
		var name = ''
		if (item?.counterparty === 'supplier') {
			name = t('supplier')
		}
		if (item?.counterparty === 'employee' || item?.counterparty === 'employee_salary') {
			name = t('employee')
		}
		if (item?.counterparty === 'agent') {
			name = t('agent')
		}
		if (item?.counterparty === 'organization') {
			name = t('organization')
		}
		if (item?.counterparty === 'client') {
			name = t('client')
		}

		return name || '—'
	}

	function returnStyle(item) {
		if (!item.parent_id) {
			return { fontWeight: 700, color: 'var(--dark-text-strong, #111827)', fontSize: '13px' }
		}
		if (level === 1) {
			return { paddingLeft: `${(level + 1) * 10}px`, fontSize: '12.5px', fontWeight: 600, color: 'var(--dark-text-strong, #1f2937)' }
		}
		if (level > 1) {
			return { paddingLeft: `${(level + 1) * 12}px`, fontSize: '12.5px', color: 'var(--dark-text, #374151)' }
		}
		return {}
	}

	function balanceColor(value) {
		const amount = Number(value)
		if (!Number.isFinite(amount) || amount === 0) return '#6b7280'
		if (amount < 0) return '#d23434'
		return '#111827'
	}

	return (
		<>
			{children.map((item, index) => {
				const isRoot = !item.parent_id
				const borderBottom = "1px solid var(--dark-border, #e8edf2)"
				const rowBg = isRoot ? "var(--dark-surface-2, #f8fafc)" : (index % 2 === 0 ? "transparent" : "var(--dark-surface-2, #fcfcfd)")

				return (
					<React.Fragment key={item.id ?? `${level}-${index}`}>
						<tr style={{ background: rowBg, opacity: item.is_hidden ? 0.55 : 1 }}>
							<td className={`child-${item.id} cursor py-1`}
								style={{ ...returnStyle(item), borderBottom, lineHeight: 1.25 }}
								onClick={() => selectItem(item)}
								onDoubleClick={() => openTransactions && openTransactions(item)}
								title={t('preview')}>
								{item.children?.length > 0 &&
									<i className="uil uil-angle-down me-1" style={{ color: 'var(--dark-text-muted, #8791a1)', fontSize: '14px' }}></i>
								}
								{!item.parent_id ? <b>{item.name}</b> : <span>{item.name}</span>}
								{item.share_percent != null &&
									<span className="badge bg-primary ms-2" title={t('profit_share')}>{item.share_percent}%</span>
								}
								{item.allow_negative === false &&
									<i className="uil uil-lock ms-1" title={t('restrict_negative_balance')}
										style={{ color: 'var(--dark-fg-danger, #d23434)', fontSize: '12px' }}></i>
								}
								{item.is_hidden &&
									<i className="uil uil-eye-slash ms-1" title={t('hidden_account')}
										style={{ color: 'var(--dark-text-muted, #8791a1)', fontSize: '12px' }}></i>
								}
							</td>
							<td className="py-1 text-muted" style={{ borderBottom, fontSize: '12.5px', lineHeight: 1.25 }}>{item.code || '—'}</td>
							<td className="py-1" style={{ borderBottom, fontSize: '12.5px', lineHeight: 1.25 }}>{item.account_type_name || '—'}</td>
							<td className="py-1 text-muted" style={{ borderBottom, fontSize: '12.5px', lineHeight: 1.25 }}>{returnEntityType(item)}</td>
							<td className="py-1 text-end" style={{ borderBottom, fontSize: '12.5px', lineHeight: 1.25, fontWeight: 700, color: balanceColor(item.balance) }}>
								{item.balance == null || item.balance === '' ? '—' : formatMoney(item.balance, 2)}
							</td>
							<td className="py-1 text-end text-nowrap" style={{ borderBottom, lineHeight: 1.25 }}>
								{!(item.children?.length > 0) &&
									<i className="uil uil-balance-scale cursor me-2"
										title={t('correct_balance')}
										style={{ color: 'var(--dark-text-muted, #8791a1)', fontSize: '14px' }}
										onClick={(e) => { e.stopPropagation(); openCorrection && openCorrection(item) }}></i>
								}
								<i className="uil uil-eye cursor me-2"
									title={t('preview')}
									style={{ color: 'var(--dark-text-muted, #8791a1)', fontSize: '14px' }}
									onClick={(e) => { e.stopPropagation(); openTransactions && openTransactions(item) }}></i>
								<i className="uil uil-edit-alt cursor"
									title={t('edit')}
									style={{ color: 'var(--dark-text-muted, #8791a1)', fontSize: '14px' }}
									onClick={(e) => { e.stopPropagation(); editItem(item) }}></i>
								{/* Удалить можно только свой конечный счёт; проводки и ссылки проверяет сервер.
									«Основной» подсчёт — только последним в группе (delete_locked) */}
								{item.is_own && !(item.children?.length > 0) && !item.delete_locked &&
									<i className="uil uil-trash-alt cursor ms-2"
										title={t('delete')}
										style={{ color: 'var(--dark-fg-danger, #d23434)', fontSize: '14px' }}
										onClick={(e) => { e.stopPropagation(); deleteItem && deleteItem(item) }}></i>
								}
							</td>
						</tr>

						{item.children && item.children.length > 0 && (
							<Tree
								children={item.children}
								selectItem={selectItem}
								editItem={editItem}
								openTransactions={openTransactions}
								openCorrection={openCorrection}
								deleteItem={deleteItem}
								level={level + 1}
							/>
						)}
					</React.Fragment>
				)
			})}
		</>
	);
};

export default Tree;
